module.exports = __webpack_public_path__ + "img/loading-quote-img-8.a837f067.png";